import axios, { AxiosError } from "axios"
import { requestInterceptorErrorSecurityCredentials, requestInterceptorSuccessCredentials, responseInterceptorErrorCredentials, responseInterceptorSuccessCredentials } from "interceptors"
import { ICharts } from "model/ChartsModel"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)


export const wsObtenerCharts = async () => {
  try {
    const result = await instance.get(`/charts`)
    return result.data as ICharts
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
